<script type="text/jsx">
import {
  StyledUploader,
  StyledLabel,
  StyledText,
  StyledContent,
  StyledFile,
  StyledClose,
  StyledProgress
} from './StyledUploader'

export default {
  name: 'Uploader',
  data: () => ({
    isDragging: false,
    files: [],
    filesShow: [],
    loading: false,
    dragCount: 0
  }),
  render () {
    const files = this.filesShow.map((file, index) => {
      return (
        <StyledFile>
          <StyledClose onClick={() => { this.removeFile(index) }}>
            <img src="static/img/close-file.png" alt="" />
          </StyledClose>
          {this.files[index].type.match('image.*') ? (
            <img src={file} alt={`FileUpload ${index}`}/>
          ) : (
            <video src={file}></video>
          )}
        </StyledFile>
      )
    })

    return (
      <StyledUploader>
        <div
          onDragenter={(e) => { this.onDragEnter(e) }}
          onDragleave={(e) => { this.onDragLeave(e) }}
          onDrop={(e) => { this.onDrop(e) }}
          onDragover={(e) => { e.preventDefault() }}
        >
          <StyledLabel for="file" active={this.isDragging}>
            <figure>
              <img src="static/img/svg/file-download.svg" alt="" />
            </figure>
            <StyledText>{this.$t('request.labels.file.no-select')}</StyledText>
          </StyledLabel>
          <input type="file" id="file" multiple onChange={(e) => { this.onChange(e) }} />
        </div>
        {(this.filesShow.length > 0) && <StyledContent>
          {files}
        </StyledContent>
        }
        {this.loading && <StyledProgress />}
      </StyledUploader>
    )
  },
  methods: {
    onDragEnter (e) {
      e.preventDefault()

      this.dragCount++
      this.isDragging = true
    },
    onDragLeave (e) {
      e.preventDefault()

      this.dragCount--

      if (this.dragCount <= 0) {
        this.isDragging = false
      }
    },
    onChange (e) {
      e.preventDefault()
      this.getFiles(e.target.files)
    },
    async getFiles (files) {
      await Object.keys(files).map((key) => {
        this.addFile(files[key])
      })

      // const objFiles = this.files.reduce((acc, cur, i) => (acc[i] = cur), {})
      this.$emit('change-files', this.files)
    },
    onDrop (e) {
      e.preventDefault()
      e.stopPropagation()
      this.isDragging = false

      this.getFiles(e.dataTransfer.files)
    },
    isPrime (file) {
      return this.files.find((item) => {
        return item.name === file.name
      })
    },
    addFile (file) {
      if (!file.type.match('image.*') && !file.type.match('video.*')) {
        return
      }

      if (this.isPrime(file)) {
        return
      }

      this.files.push(file)

      const reader = new FileReader()

      reader.onload = (e) => {
        this.filesShow.push(e.target.result)
      }

      reader.readAsDataURL(file)

      reader.onloadstart = () => {
        this.loading = true
      }

      reader.onloadend = () => {
        this.loading = false
      }
    },
    removeFile (index) {
      this.filesShow.splice(index, 1)
      this.files.splice(index, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Uploader/Uploader.vue